import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useContactModal } from '../context/ContactModalContext';
import '../styles/components/SiteChrome.css';

function SiteFooter() {
  const location = useLocation();
  const navigate = useNavigate();
  const { openContactModal } = useContactModal();

  const goToSection = (id) => (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <footer className="st-footer" data-nav-tone="dark">
      <div className="st-footer-cta">
        <p className="st-footer-kicker">Contact</p>
        <h2>
          Have a project in mind?
          <br />
          <em>Let&rsquo;s talk.</em>
        </h2>
        <button type="button" className="st-footer-cta-link" onClick={() => openContactModal('demo')}>
          Tell us about it
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 20 20 4M9 4h11v11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="square" />
          </svg>
        </button>
      </div>

      <div className="st-footer-grid">
        <div className="st-footer-brand">
          <img src="/logo.png" alt="" className="st-footer-glyph" />
          <p>
            A tech research lab and innovation studio in Goa - geospatial, research, finance,
            operations, and compliance, from development to deployment.
          </p>
        </div>

        <div className="st-footer-col">
          <h4>Studio</h4>
          <a href="/#about" onClick={goToSection('about')}>About</a>
          <a href="/#what" onClick={goToSection('what')}>What we build</a>
          <a href="/#how" onClick={goToSection('how')}>How we work</a>
          <Link to="/pricing">Pricing</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="st-footer-col">
          <h4>Platform</h4>
          <Link to="/products">Products</Link>
          <Link to="/login">Client login</Link>
          <Link to="/pricing">Plans</Link>
          <Link to="/account-deletion">Account deletion</Link>
        </div>

        <div className="st-footer-col">
          <h4>Legal</h4>
          <Link to="/privacy">Privacy policy</Link>
          <Link to="/terms">Terms &amp; conditions</Link>
          <Link to="/refund">Refund policy</Link>
        </div>
      </div>

      <div className="st-footer-bottom">
        <span>&copy; {new Date().getFullYear()} CLIVEXCI SYSTEMS LLP</span>
        <span className="st-footer-dot" aria-hidden="true" />
        <span>Engineered in Goa, India</span>
        <span className="st-footer-dot" aria-hidden="true" />
        <span>All rights reserved</span>
      </div>
    </footer>
  );
}

export default SiteFooter;
